export default __webpack_public_path__ + "assets/img/avatar-2.85178a9.png";